import { rankMedal, podiumClass } from '@/lib/leaderboard';
import type { PlayerWithId } from '@/hooks/usePlayers';
import { useCurrentPlayerId } from '@/app/store';

interface IndividualTableProps {
  players: PlayerWithId[];
  startRank?: number;
}

export function IndividualTable({ players, startRank = 0 }: IndividualTableProps) {
  const currentId = useCurrentPlayerId();
  const sorted = players;

  if (sorted.length === 0) {
    return (
      <div className="lb-empty">
        👋 ¡Sé el primero en jugar y aparecer en el ranking!
      </div>
    );
  }

  return (
    <div className="lb-table-wrap">
      <table className="lb-table">
        <thead>
          <tr>
            <th className="col-rank">#</th>
            <th>Participante</th>
            <th>Empresa</th>
            <th className="col-pos">Posición</th>
            <th className="r col-game">⚡ G1</th>
            <th className="r col-game">🎮 G2</th>
            <th className="r col-game">🔍 G3</th>
            <th className="r col-total">TOTAL</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((p, i) => {
            const absoluteIdx = startRank + i;
            const isMe = p.id === currentId;
            return (
              <tr key={p.id} className={`lb-row ${podiumClass(absoluteIdx)} ${isMe ? 'is-me' : ''}`}>
                <td className="col-rank">
                  <span className="rank-num">{rankMedal(absoluteIdx)}</span>
                </td>
                <td>
                  <strong>{p.name}</strong>
                  {isMe && <span className="me-tag">tú</span>}
                </td>
                <td className="cell-company">{p.company}</td>
                <td className="col-pos">
                  <span className="pos-chip">{p.position}</span>
                </td>
                <td className={`r col-game ${!p.gPlayed.g1 ? 'dim' : ''}`}>
                  {p.gPlayed.g1 ? p.scores.g1.toLocaleString() : '—'}
                </td>
                <td className={`r col-game ${!p.gPlayed.g4 ? 'dim' : ''}`}>
                  {p.gPlayed.g4 ? (p.scores.g4 ?? 0).toLocaleString() : '—'}
                </td>
                <td className={`r col-game ${!p.gPlayed.g3 ? 'dim' : ''}`}>
                  {p.gPlayed.g3 ? p.scores.g3.toLocaleString() : '—'}
                </td>
                <td className="r col-total">
                  <strong>{p.scores.total.toLocaleString()}</strong>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
